
import '../../base_builders/vertical/rcp/rcp_base_vendor_builder.js';
import '../../base_builders/vertical/rcp/rcp_base_builder';
import { rcmg_setLocalCookies } from '../../../assets/js/RCMG_V2/RcmgAuth.js';
import axios from 'axios';
import Vue from 'vue';

window.rcmg_setLocalCookies = rcmg_setLocalCookies;

const CouponsApp = () => import(/* webpackChunkName: "CouponsApp" */ "../../../assets/js/Coupons/CouponApp.vue"); 

function init_app() {

    if (window.Vue) {

        Vue.prototype.$http = axios;

        Vue.mixin({
            methods: {
                browser_has_storage: function () {
                    return (window.localStorage) ? true : false;
                },
            },
        });

        if(document.getElementById('coupons_app')){
            window.coupons_app = new Vue({
                name: 'coupons-page-app',
                el: '#coupons_app',
                render: h => h(CouponsApp),
            });
        }

    }

}
init_app();